module.exports = __webpack_public_path__ + "img/av023.9bf85eaa.png";